import { Stack } from "components/icons/generated";
import useSearchStacksForNavigation from "shared/Stack/useSearchStacksForNavigation";

import CommandPaletteEntitySearch from "./EntitySearch";

const useSearchHook = ({ query }: { query: string }) => {
  return useSearchStacksForNavigation({ query, first: 10 });
};

const CommandPaletteSubListViewStacksSearch = () => (
  <CommandPaletteEntitySearch
    useSearchHook={useSearchHook}
    icon={Stack}
    pathPrefix="/stack/"
    entityName="stacks"
  />
);

export default CommandPaletteSubListViewStacksSearch;
